import gql from 'graphql-tag';
import { useQuery, useResult } from '@vue/apollo-composable';
import dateUtils from '@utils/date.utils';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import cookieUtils from '@utils/cookie.utils';
import baseConfig from '@config/base.config';

const QUERY = gql`
    query dataPlatformData($where: DataPlatformDataWhereUniqueInput!) {
        dataPlatformData(where: $where)
    }
`;

export type TopMetricsWhere = {
    sid: string;
    startTime: string;
    endTime: string;
    funName: string;
    limit: number;
    path: string;
};

export function useTopMetrics(params?: {
    sid?: string;
    timezone?: string;
    funName?: string;
    path?: string;
    startTime?: string;
    endTime?: string;
    filter?: {
        filterKey: string;
        filterValue: string;
    };
}) {
    const route = useRoute();
    const { profileInfo } = useProfileInfo();
    const startTime = dateUtils.getMomentTime({
        num: -6,
        type: 'day',
        isStart: true,
        timezone: params?.timezone || profileInfo.value?.timeZone
    } as any);
    const endTime = dateUtils.getMomentTime({
        num: 0,
        type: 'day',
        isStart: true,
        timezone: params?.timezone || profileInfo.value?.timeZone
    } as any);

    const {
        result,
        refetch: refetchTopMetrics,
        loading: topMetricsLoading,
        error: topMetricsError,
        onError: onTopMetricsError,
        onResult: onTopMetricsResult
    } = useQuery<{ dataPlatformData: any }>(
        QUERY,
        {
            where: {
                sid:
                    params?.sid ||
                    route.params?.sid ||
                    cookieUtils.getItem(baseConfig.LAST_PROFILE_ID),
                startTime: params?.startTime || startTime,
                endTime: params?.endTime || endTime,
                funName: params?.funName || 'cutUrl',
                limit: 100,
                sort: 'engage',
                path: params?.path || 'top_metrics',
                filter: params?.filter
            }
        },
        {
            fetchPolicy: 'cache-and-network'
        }
    );
    const userTopMetricsResult = useResult(
        result,
        null,
        data => data?.dataPlatformData?.currentResult
    );
    const topMetrics = computed(() => {
        let result: any = [];
        if (userTopMetricsResult.value && userTopMetricsResult.value?.length > 0) {
            userTopMetricsResult.value.map((item: any, i: any) => {
                result.push({
                    label: i,
                    value: item
                });
            });
        }
        return result;
    });
    /**
     * 显示预置下拉搜索列表
     */
    const querySearch = (queryString: string, cb: any) => {
        const results = queryString
            ? (topMetrics.value || []).filter(createFilter(queryString))
            : topMetrics.value || [];
        cb(results);
    };

    const createFilter = (queryString: string) => {
        return topMetric => {
            return topMetric.value?.toLowerCase().indexOf(queryString?.toLowerCase()) !== -1;
        };
    };
    return {
        data: topMetrics,
        topMetricsLoading,
        topMetricsError,
        querySearch,
        refetchTopMetrics,
        onTopMetricsError,
        onTopMetricsResult
    };
}
